module.exports = __webpack_public_path__ + "static/media/tags.748c6460.svg";